import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { MoreVertical, Pencil, Plus, ArrowRightLeft, Trash2 } from 'lucide-react'
import type { TeamTreeNode } from './TeamTree'

interface TeamActionsProps {
  team: TeamTreeNode
  onEdit: () => void
  onAddChild: () => void
  onMove: () => void
  onDelete: () => void
}

export function TeamActions({ team, onEdit, onAddChild, onMove, onDelete }: TeamActionsProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-7 shrink-0"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="size-4" />
          <span className="sr-only">Team actions</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onEdit} className="flex items-center gap-2">
          <Pencil className="size-4" />
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onAddChild} className="flex items-center gap-2">
          <Plus className="size-4" />
          Add Child
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onMove} className="flex items-center gap-2">
          <ArrowRightLeft className="size-4" />
          Move
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onDelete} className="flex items-center gap-2 text-destructive focus:text-destructive">
          <Trash2 className="size-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
